import { ErrorText, SectionTitle, SwitchButtons } from '@elotech/components';
import PropTypes from 'prop-types';
import React from 'react';

import RequerenteForm from '../RequerenteForm';
import ValoresTransferenciaSection from '../valores/ValoresTransferenciaSection';
import DadosTransferencia from './DadosTransferenciaForm';
import Documento from './DocumentoForm';
import LocalizacaoImovelRural from './LocalizacaoImovelRural';
import LocalizacaoImovelUrbano from './LocalizacaoImovelUrbano';
import Observacao from './ObservacaoForm';
import PesquisaCadastroImovel from './PesquisaCadastroImovel';
import Requerente from './Requerente';

const tiposImovel = [
  { key: 'URBANO', value: 'URBANO', label: 'Urbano' },
  { key: 'RURAL', value: 'RURAL', label: 'Rural' }
];
const Imovel = ({
  camposLocalizacao,
  dadosImoveis,
  handleChangeFieldCurrency,
  handleChangeValoresItbi,
  handleChangeSelectTipoItbi,
  handleChangeSelectRequerente,
  handleChangeCadastroImobiliario,
  handleClearCadastroImobiliario,
  handleKeyDownCadastroImobiliario,
  handleBlurCadastroImobiliario,
  handleChangeFieldDocument,
  handleChangeField,
  errorMessages,
  handleChangeUploadFile,
  handleRemoveFile,
  listRequerentes,
  isServidor,
  onChangeInputValue,
  onChangeInputCpfCnpj,
  permiteItbiRural,
  permiteCriacaoCadastroRuralItbi,
  permiteBuscaPorInscricaoCadastral,
  handleChangeCadastroRural,
  handleBlurCadastroRural,
  handleSelectCadastroPesquisa,
  valorRecursoProprio,
  utilizaFluxoAutonomiaCidadao,
  disabled = false
}) => {
  return (
    <div>
      {isServidor ? (
        <RequerenteForm
          title="Requerente"
          errors={dadosImoveis.error.requerente}
          currentPerson={dadosImoveis.requerente}
          isProprietarioAise={false}
          errorMessages={errorMessages.requerente}
          onChangeInputValue={onChangeInputValue}
          onChangeInputCpfCnpj={onChangeInputCpfCnpj}
          isServidor={isServidor}
        />
      ) : (
        <Requerente
          requerente={dadosImoveis.requerente}
          listRequerentes={listRequerentes}
          onChangeSelect={handleChangeSelectRequerente}
          error={dadosImoveis.error}
          errorMessages={errorMessages}
        />
      )}
      <SectionTitle>Dados da Transferência</SectionTitle>
      <DadosTransferencia
        tipoItbi={dadosImoveis.tipoItbi}
        valorTransacao={dadosImoveis.valorTransacao}
        valorFinanciado={dadosImoveis.valorFinanciado}
        valorFinanciadoAvaliacao={dadosImoveis.valorFinanciadoAvaliacao}
        listTipoItbi={dadosImoveis.listTipoItbi}
        onChange={handleChangeFieldCurrency}
        onChangeSelect={handleChangeSelectTipoItbi}
        error={dadosImoveis.error}
        errorMessages={errorMessages}
        valorRecursoProprio={valorRecursoProprio}
        utilizaFluxoAutonomiaCidadao={utilizaFluxoAutonomiaCidadao}
        disabled={disabled}
      />
      {utilizaFluxoAutonomiaCidadao && dadosImoveis.tipoItbi?.value && (
        <ValoresTransferenciaSection
          tipoItbi={dadosImoveis.tipoItbi}
          valoresItbi={{
            valorTransacao: dadosImoveis.valorTransacao || 0,
            valorTransacaoAvaliacao: dadosImoveis.valorTransacaoAvaliacao || 0,
            aliquotaTransacao: dadosImoveis.aliquotaTransacao || 0,
            valorTransacaoItbi: dadosImoveis.valorTransacaoItbi || 0,
            valorIsencao: dadosImoveis.valorIsencao || 0,
            valorOriginal: dadosImoveis.valorOriginal || 0
          }}
          valoresFinanciamento={{
            valorFinanciado: dadosImoveis.valorFinanciado || 0,
            valorFinanciadoAvaliacao:
              dadosImoveis.valorFinanciadoAvaliacao || 0,
            aliquotaFinanciado: dadosImoveis.aliquotaFinanciado || 0,
            valorFinanciadoItbi: dadosImoveis.valorFinanciadoItbi || 0
          }}
          valorCalculado={0}
          onChangeValoresItbi={handleChangeValoresItbi}
          onChangePercentualIsencaoItbi={handleChangeFieldCurrency}
          errors={dadosImoveis.error}
          errorMessages={errorMessages}
          onShowAvaliacoes={() => {}}
          hasRole={() => false}
          onChangeObservacao={handleChangeField}
          observacaoIsencao={dadosImoveis.observacaoIsencao}
          isServidor={isServidor}
          retificadora={dadosImoveis.retificadora || false}
          utilizaFluxoAutonomiaCidadao={utilizaFluxoAutonomiaCidadao}
          valorRecursoProprio={valorRecursoProprio}
        />
      )}
      <SectionTitle>
        {isServidor ? 'Pesquisa Cadastral' : 'Dados do Imóvel'}
      </SectionTitle>
      <div
        style={{
          pointerEvents: disabled ? 'none' : 'auto',
          opacity: disabled ? 0.6 : 1
        }}
      >
        {!isServidor && permiteItbiRural && (
          <>
            <label className="label">Tipo do Imóvel</label>
            <SwitchButtons
              value={dadosImoveis.tipoImovel}
              onChange={value =>
                handleChangeField({ target: { value, name: 'tipoImovel' } })
              }
              name="tipoImovel"
              options={tiposImovel}
            />
          </>
        )}

        {isServidor ? (
          <>
            <PesquisaCadastroImovel
              camposLocalizacao={camposLocalizacao}
              tipoImovel={dadosImoveis.tipoImovel}
              onChangeTipoImovel={value =>
                handleChangeField({ target: { value, name: 'tipoImovel' } })
              }
              permiteItbiRural={permiteItbiRural}
              onSelect={handleSelectCadastroPesquisa}
              onChangeNumero={value =>
                handleChangeCadastroImobiliario({
                  target: { name: 'numero', value }
                })
              }
              cadastroSelecionado={
                dadosImoveis.tipoImovel === 'URBANO'
                  ? dadosImoveis.cadastroImobiliario
                  : dadosImoveis.cadastroRural
              }
              loadingSelecao={
                dadosImoveis.cadastroImobiliarioLoading ||
                dadosImoveis.cadastroRuralLoading
              }
            />
            {dadosImoveis.error.cadastroInadimplente && (
              <ErrorText>{errorMessages.cadastroInadimplente}</ErrorText>
            )}
            {dadosImoveis.error.numeroEndereco && (
              <ErrorText>{errorMessages.numeroEnderecoLength}</ErrorText>
            )}
          </>
        ) : dadosImoveis.tipoImovel === 'URBANO' ? (
          <LocalizacaoImovelUrbano
            permiteBuscaPorInscricaoCadastral={
              permiteBuscaPorInscricaoCadastral
            }
            cadastroImobiliario={dadosImoveis.cadastroImobiliario}
            onChangeField={handleChangeCadastroImobiliario}
            onClearCadastroImobiliario={handleClearCadastroImobiliario}
            onKeyDownCadastroImobiliario={handleKeyDownCadastroImobiliario}
            onBlurCadastroImobiliario={handleBlurCadastroImobiliario}
            error={dadosImoveis.error}
            loading={dadosImoveis.cadastroImobiliarioLoading}
            errorMessages={errorMessages}
            isServidor={isServidor}
            camposLocalizacao={camposLocalizacao}
          />
        ) : (
          <LocalizacaoImovelRural
            cadastro={dadosImoveis.cadastroRural}
            handleBlurCadastroRural={handleBlurCadastroRural}
            onChangeCadastro={handleChangeCadastroRural}
            loading={dadosImoveis.cadastroRuralLoading}
            errorMessages={errorMessages}
            error={dadosImoveis.error}
            notFound={dadosImoveis.ruralNotFound}
            permiteCriacaoCadastroRuralItbi={permiteCriacaoCadastroRuralItbi}
            camposLocalizacao={camposLocalizacao}
          />
        )}

        <Documento
          documentos={dadosImoveis.documentos}
          onChangeField={handleChangeFieldDocument}
          onChangeUploadFile={handleChangeUploadFile}
          onRemoveFile={handleRemoveFile}
        />

        <Observacao
          observacao={dadosImoveis.observacaoCidadao}
          onChangeField={handleChangeField}
        />
      </div>
    </div>
  );
};

Imovel.propTypes = {
  dadosImoveis: PropTypes.object.isRequired,
  handleChangeFieldCurrency: PropTypes.func.isRequired,
  handleChangeValoresItbi: PropTypes.func.isRequired,
  handleChangeSelectTipoItbi: PropTypes.func.isRequired,
  handleChangeSelectRequerente: PropTypes.func.isRequired,
  handleChangeCadastroImobiliario: PropTypes.func.isRequired,
  handleClearCadastroImobiliario: PropTypes.func.isRequired,
  handleKeyDownCadastroImobiliario: PropTypes.func.isRequired,
  handleBlurCadastroImobiliario: PropTypes.func.isRequired,
  handleChangeFieldDocument: PropTypes.func.isRequired,
  handleChangeField: PropTypes.func.isRequired,
  handleChangeUploadFile: PropTypes.func.isRequired,
  handleRemoveFile: PropTypes.func.isRequired,
  isServidor: PropTypes.bool,
  handleSelectCadastroPesquisa: PropTypes.func,
  onChangeInputValue: PropTypes.func.isRequired,
  onChangeInputCpfCnpj: PropTypes.func.isRequired,
  listRequerentes: PropTypes.array,
  parametrosItbiCarregados: PropTypes.bool,
  permiteCriacaoCadastroRuralItbi: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Imovel;
